export default __webpack_public_path__ + "static/media/img_12.1a0ee022.JPG";